/* KUGOK — Collection page hover image cycling */
(function () {
  'use strict';

  function initCardHover() {
    document.querySelectorAll('[data-kugok-card]').forEach(function (card) {
      if (card._kugokHoverTargetInit) return;
      card._kugokHoverTargetInit = true;
      var imgs = card.querySelectorAll('.kugok-card-img');
      if (imgs.length <= 1) return;

      var idx = 0;
      var timer = null;
      var fill = card.querySelector('.kugok-progress-fill');
      var hoverTarget = card.closest('.card') || card;

      function showSlide(i) {
        imgs.forEach(function (img) { img.classList.remove('kugok-card-img--active'); });
        imgs[i].classList.add('kugok-card-img--active');
        if (fill) {
          fill.style.transition = 'none';
          fill.style.width = '0%';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              fill.style.transition = 'width 1s linear';
              fill.style.width = '100%';
            });
          });
        }
      }

      hoverTarget.addEventListener('mouseenter', function () {
        idx = 1 % imgs.length;
        showSlide(idx);
        timer = setInterval(function () {
          idx = (idx + 1) % imgs.length;
          showSlide(idx);
        }, 1000);
      });

      hoverTarget.addEventListener('mouseleave', function () {
        clearInterval(timer);
        timer = null;
        idx = 0;
        imgs.forEach(function (img) { img.classList.remove('kugok-card-img--active'); });
        imgs[0].classList.add('kugok-card-img--active');
        if (fill) {
          fill.style.transition = 'none';
          fill.style.width = '0%';
        }
      });

      /* Mobile taps keep their native link behaviour. Image cycling is desktop-hover only. */
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardHover);
  } else {
    initCardHover();
  }

  new MutationObserver(initCardHover).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
